






















import { Component, Vue, Watch } from "vue-property-decorator";
import homeTop from "./homeTop.vue";
import homeFooter from "./footer.vue";
@Component({
  components: { homeTop, homeFooter },
})
export default class Home extends Vue {
  public activeMenu = "";
  public value = "1";
  public showToTop = false;
  public routerState = true;
  public showList = true;
  public showNav = true;
  public breadList = [];
  @Watch("$route", { immediate: true })
  public change(item) {
    if (item.meta.showList == 0) {
      this.showList = false;
    } else {
      this.showList = true;
    }
    this.breadList = [];
    if (item.meta.showNav == false || item.meta.showNav == undefined) {
      this.breadList = item.meta.menu;
      this.showNav = false;
    } else {
      this.breadList = item.meta.menu;
      this.showNav = true;
    }
  }
  public reload() {
    this.routerState = false;
    setTimeout(() => {
      this.routerState = true;
    });
  }
  public mounted() {
    // this.$Message.info({
    //   content: "'I'll be gone in 10 seconds'",
    //   duration: 0,
    // });
    // 监听滚动条
    // this.switchOver();
    window.addEventListener("scroll", this.handleScroll, true);
    (this as any).$Spin.hide();
  }
  public handleScroll() {
    // let windowScrollY = window.scrollY;
    const windowScrollY =
      window.pageYOffset || // 用于FF
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (windowScrollY > 500) {
      // 当滚动大于一屏高度时的操作
      this.showToTop = true;
      //   console.log(11);
    } else {
      // 当滚动小于于一屏高度时的操作
      this.showToTop = false;
      //   console.log(22);
    }
  }
  public toTop() {
    // alert(document.body.scrollTop)
    if (document.body.scrollTop > 0) {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollTop - 30;
        this.toTop();
      });
    }
  }
}
